import { inject, Injectable } from '@angular/core';
import { Action, Selector, State, StateContext } from '@ngxs/store';
import { UserActions } from './user.action';
import { UserStateModel } from './user.store';
import { User, UserInfo } from '@firebase/auth';
import { Auth } from '@angular/fire/auth';

@State<UserStateModel>({
  name: 'users',
  defaults: {
    user: null,
  },
})
@Injectable()
export class UserState {
  authService = inject(Auth);

  @Action(UserActions.SetUser)
  setUser(ctx: StateContext<UserStateModel>, { user }: UserActions.SetUser) {
    ctx.patchState({ user });
  }

  @Action(UserActions.UpdateUser)
  async updateUsers(ctx: StateContext<UserStateModel>, { user }: UserActions.UpdateUser) {
    if (this.authService.currentUser)
      await this.authService.updateCurrentUser({ ...this.authService.currentUser, ...user } as User);
  }

  @Action(UserActions.DeleteUsers)
  async saveUser(ctx: StateContext<UserStateModel>, { uid: _uid }: UserActions.DeleteUsers) {
    await this.authService.currentUser?.delete();
    ctx.setState({ user: null });
  }

  @Selector()
  static user(state: UserStateModel) {
    return state.user;
  }

  @Selector()
  static providerDataWithIsVerified(state: UserStateModel): { userInfo: UserInfo[] | null; emailVerified: boolean } {
    return { userInfo: state.user?.providerData || null, emailVerified: state.user?.emailVerified || false };
  }
}
